import React, { useState } from 'react'
import {
  Modal,
  SelectAsync,
  Button
} from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl } from 'react-intl'
import messages from './messages'
import { useEffect } from 'react'

export default NiceModal.create(({ history, duplicate = false, orderId = null }) => {
  const { formatMessage } = useIntl()
  const modal = useModal()
  const [customer, setCustomer] = useState(null)
  const [contact, setContact] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingDefaultContact, setLoadingDefaultContact] = useState(false)
  const url = duplicate ? `/rest/v2/order/${orderId}/duplicate` : '/rest/v2/order/skeleton'

  const loadCustomerOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/customer?search[name]=${query}`)
        .then(response => response.json())
        .then(({data}) => {
          resolve(data.map(({ uid, name, defaultcontact }) => ({
            value: uid,
            label: name,
            defaultContact: defaultcontact
          })))
        })
        .catch(reject)
    })
  }, 250)
  
  const loadContactOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v1/customer/${customer.value}/contacts?search[name]=${query}`)
        .then(response => response.json())
        .then((data) => {
          resolve(data.map(({ uid, name }) => ({
            value: uid,
            label: name
          })))
        })
        .catch(reject)
    })
  }, 250)

  const onSubmit = () => {
    setLoading(true)
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        customerId: customer.value,
        contactId: contact?.value
      })
    })
    .then((response) => response.json())
    .then(({success, data, errors}) => {
      setLoading(false)
      if (success) {
        history.push(`/orders/${data.uid}/overview`)
        modal.resolve()
        modal.remove()
      } else {
        toastr.error(errors)
      }
    }).catch((error) => {
      toastr.error(error)
    })
  }

  const onCustomerChangeHandler = (selectedCustomer) => {
    setCustomer(selectedCustomer)
    if (!!(+selectedCustomer?.defaultContact)) {
      setLoadingDefaultContact(true)
      fetch(`/rest/v2/user/${selectedCustomer.defaultContact}`)
        .then(response => response.json())
        .then(({data}) => {
          setContact({
            label: data.name,
            value: data.uid
          })
          setLoadingDefaultContact(false)
        })
        .catch(setLoadingDefaultContact(false))
    }
  }

  const closeModal = () => {
    modal.remove()
    history.goBack()
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => closeModal()}
      onOutsideClick={() => closeModal()}
      onSubmit={() => (!customer || loading) ? undefined : onSubmit()}
      dialogPanelClasses="overflow-y-visible"
      title={formatMessage(messages.title)}
    >
      <div className="m-4 space-y-4">
        <SelectAsync
          label={formatMessage(messages.customerSelectLabel)}
          description={formatMessage(messages.customerSelectDescription)}
          value={customer} 
          onChange={(customer) => {
            onCustomerChangeHandler(customer)
          }}
          disabled={loading}
          cacheOptions
          loadOptions={(query) => loadCustomerOptions(query)}
          placeholder={formatMessage(messages.customerSelectPlaceholder)}
        />
      </div>
      <div className="m-4 space-y-4">
        <SelectAsync
          containerProps={{className: !customer || loading || loadingDefaultContact ? 'cursor-not-allowed' : ''}}
          label={formatMessage(messages.contactSelectLabel)}
          description={formatMessage(messages.contactSelectDescription)}
          value={contact} 
          onChange={(contact) => {
            setContact(contact)
          }}
          defaultOptions
          isDisabled={!customer || loading || loadingDefaultContact}
          cacheOptions
          loadOptions={(query) => loadContactOptions(query)}
          placeholder={formatMessage(messages.contactSelectPlaceholder)}
        />
      </div>

      <Button
        className="float-right"
        size="sm"
        onClick={onSubmit}
        disabled={!customer || loading || loadingDefaultContact}
      >
        {duplicate ? (
          loading ? formatMessage(messages.duplicateLoading) : formatMessage(messages.duplicateOrder)
        ) : (
          loading ? formatMessage(messages.createLoading) : formatMessage(messages.createOrder)
        )}
      </Button>
    </Modal>
  )
})
